let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iaIlg")).then(() => parcelRequire('el8fJ'));